module.exports = __webpack_public_path__ + "static/media/close-accordion.cea96be9.svg";